export default "__VITE_ASSET__B9Lvqxjy__"